import { CartScreeningModel } from "./cart-screening.model";
import { CartTicketItemModel } from "./cart-ticket-item.model";

export class CartModel {
  screeningItems: Array<CartScreeningModel> = new Array<CartScreeningModel>();
  ticketItems: Array<CartTicketItemModel> = new Array<CartTicketItemModel>();
}
